import React from "react"
import "./ResourceBannerEntityDetail.scss"
import PropTypes from "prop-types"

const ResourceBannerEntityDetail = ({ entities }) => {
  return (
    <div className="ResourceBannerEntityDetail">
      {entities.reduce((prev, curr) => [
        prev,
        <div className="entity-divider" key={curr}>
          |
        </div>,
        curr,
      ])}
      <div className="detail-divider" />
    </div>
  )
}

ResourceBannerEntityDetail.propTypes = {
  entities: PropTypes.array.isRequired,
}

export default ResourceBannerEntityDetail
